const colors = [
'#ffffff', '#000000', '#ED0A3F', '#FD0E35', '#FF681F', '#FF8833', '#FFAE42', '#FBE870', '#F1E788', '#C5E17A', '#39A655', '#0095B7', '#02A4D3', '#0066FF',  '#3C69E7', '#4F69C6', '#6456B7', '#8359A3', '#BB3385', '#FFA6C9', '#F7468A', '#AF593E', '#FDD5B1', '#8B8680'
]

export default colors
